import { Component, OnInit } from '@angular/core';
import { PeymentService } from '@api/peyment.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';
import jalaliMoment = require('jalali-moment');


@Component({
  selector: 'app-request-rial',
  templateUrl: './request-rial.component.html',
  styleUrls: ['./request-rial.component.scss'],
})
export class RequestRialComponent implements OnInit {
  startPage = 1;
  pageSize = 100;
  totalPage = 0;
  public destroy$ = new Subject<void>();
  depositRequest: any;

  constructor( private paymentService: PeymentService) {}

  ngOnInit(): void {
    this.paymentService.depositRequest(this.startPage ,this.pageSize).pipe(takeUntil(this.destroy$ )).subscribe(
      (res: any) =>{
        this.depositRequest= res;
        this.depositRequest.resResult.forEach((element): any => {
          element.createdAt = jalaliMoment(element.createdAt).format('jYYYY/jMM/jDD hh:mm');
        });
      }
    )
  }
  public getServerData(event?: PageEvent) {
    this.pageSize = event.pageSize
    this.paymentService.depositRequest( (event.pageIndex) + 1 , this.pageSize ).pipe(takeUntil(this.destroy$ )).subscribe(
      (res) =>{
        this.depositRequest = res;
  }
    )}
}
